import { useQuery, type UseQueryResult } from 'react-query'

import type { ShareService } from 'features/share/service'

/** One key for every reader and the Settings editor, so a save refreshes all. */
export const SHARE_ALLOWLIST_QUERY_KEY = 'share-allowlist'

export function useShareAllowlistQuery(
  service: ShareService,
  projectId: string,
): UseQueryResult<string[]> {
  return useQuery(
    [SHARE_ALLOWLIST_QUERY_KEY, projectId],
    () => service.fetchShareAllowlist(projectId),
    { enabled: !!projectId, refetchOnWindowFocus: false },
  )
}
